// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.gds.DiagramResponse
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { GraphicalDataSource } from "abweb/dto/gds/GraphicalDataSource";
import { KendoObservableObjectProxy } from "abweb/dto/kendo/KendoObservableObjectProxy";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class DiagramResponseBase extends KendoObservableObjectProxy {
  /** Do NOT invoke directly, instead use strongly typed createDiagramResponseBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.DiagramResponse";
  }
  initFromJson(json, deserializeContext) {
    this.initDiagramResponse(json.error != null ? json.error : null, TSOGUtils.decodeObject(json.graphicalDataSource, GraphicalDataSource, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "graphicalDataSource")), json.modelHandle != null ? json.modelHandle : null, json.warnings != null ? json.warnings : null);
  }
  initDiagramResponse(error, graphicalDataSource, modelHandle, warnings) {
    this.initKendoObservableObjectProxy();
    this._error = error;
    this._graphicalDataSource = graphicalDataSource;
    this._modelHandle = modelHandle;
    this._warnings = warnings;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    retVal["error"] = this._error;
    retVal["graphicalDataSource"] = TSOGUtils.toTSOGNativeObject(this._graphicalDataSource, serializeContext);
    retVal["modelHandle"] = this._modelHandle;
    retVal["warnings"] = this._warnings;
    return retVal;
  }
  get error() {
    return this._error;
  }
  set error(value) {
    this._error = value;
  }
  get graphicalDataSource() {
    return this._graphicalDataSource;
  }
  set graphicalDataSource(value) {
    this._graphicalDataSource = value;
  }
  get modelHandle() {
    return this._modelHandle;
  }
  set modelHandle(value) {
    this._modelHandle = value;
  }
  get warnings() {
    return this._warnings;
  }
  set warnings(value) {
    this._warnings = value;
  }
}
//# sourceMappingURL=DiagramResponseBase.js.map
